<template>
    <footer class="mt-32 text-xs text-gray-600">Built with VueJS and Tailwind. Hosted on Zeit Now</footer>
</template>

<script>
  export default {
    name: "Footer"
  }
</script>

<style scoped>

</style>
